var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-notice"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('detailTwo.nTitle')))]),_c('div',{staticClass:"rich"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.richTxt || '')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }